// Mesma lógica de local/backend/helpers/resolvePrice.js (e do equivalente
// no app mobile, Utils/ResolvePrice.ts) — resolve o preço de um combo pra
// um dia específico (precosPorDia, se cadastrado, senão price) e aplica o
// desconto de promoção do dia (descontoPorDia), se houver — cada dia
// escolhe seu próprio tipo (percentual ou R$ fixo). Date.getDay(): 0 =
// domingo, igual no JS do backend.
export const DIAS_SEMANA = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado']

export function resolvePriceForDay(price, precosPorDia, descontoPorDia, dia) {
    const precoBase = precosPorDia?.[dia] ?? price
    const desconto = descontoPorDia?.[dia]

    let precoFinal = precoBase
    if (desconto && desconto.valor > 0) {
        precoFinal = desconto.tipo === 'fixo'
            ? Math.max(0, precoBase - desconto.valor)
            : precoBase * (1 - desconto.valor / 100)
        precoFinal = Number(precoFinal.toFixed(2))
    }

    return { precoBase, precoFinal, temDesconto: precoFinal !== precoBase, desconto: desconto && desconto.valor > 0 ? desconto : null }
}

export function resolveTodayPrice(price, precosPorDia, descontoPorDia, data = new Date()) {
    return resolvePriceForDay(price, precosPorDia, descontoPorDia, DIAS_SEMANA[data.getDay()])
}
